import { useCallback, useState } from 'react';

import { HiDotsVertical } from 'react-icons/hi';
import { useHistory } from 'react-router-dom';

import { Modal } from '~/components';
import { PowerCreator } from '~/models/PowerCreator';
import { formatHMS, getSeconds } from '~/utils';

import { Container, Options, Wrapper, DeleteContainer } from './styles';

type Props = {
  data: PowerCreator;
  deleteData: (id: number) => void;
  archiveData: (id: number) => void;
  duplicateData: (id: number) => void;
};

export function Card({ data, deleteData, archiveData, duplicateData }: Props) {
  const { push } = useHistory();

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const restTime = formatHMS(
    getSeconds(data.total_time ?? '0') - getSeconds(data.total_action ?? '0'),
  );

  const handleNavigateToTrainingInfos = useCallback(() => {
    push(`/professional/lab/met-library/${data.id}/details`, data);
  }, [push, data]);

  const handleNavigateToEditTraining = useCallback(() => {
    push(`/professional/lab/power-creator/${data.id}/edit`, data);
  }, [push, data]);

  function DeleteModal() {
    return (
      <Modal isOpen={showDeleteModal} setOpen={setShowDeleteModal}>
        <DeleteContainer>
          <h1>Atenção</h1>
          <p>
            Essa função excluirá o método:
            <br />
            <strong>{data.tranning_method}</strong>.
            <br />
            <br />
            Tem certeza que deseja continuar?
          </p>

          <div>
            <button type="button" onClick={() => deleteData(data.id)}>
              Sim
            </button>
            <button type="button" onClick={() => setShowDeleteModal(false)}>
              Não
            </button>
          </div>
        </DeleteContainer>
      </Modal>
    );
  }

  return (
    <Container>
      <DeleteModal />

      <Options>
        <HiDotsVertical size={22} color="#000" />

        <div>
          <button onClick={handleNavigateToEditTraining} type="button">
            Editar
          </button>

          <div className="divider" />

          <button onClick={() => archiveData(data.id)} type="button">
            Arquivar
          </button>

          <div className="divider" />

          <button onClick={() => duplicateData(data.id)} type="button">
            Duplicar
          </button>

          <div className="divider" />

          <button onClick={() => setShowDeleteModal(true)} type="button">
            Excluir
          </button>
        </div>
      </Options>

      <Wrapper onClick={handleNavigateToTrainingInfos}>
        <div>
          <strong>Método:&nbsp;</strong>
          {data.tranning_method ?? 'Não informado'}
        </div>

        <div>
          <strong>Princípio ativo:&nbsp;</strong>
          {data.method_principle ?? 'Não informado'}
        </div>

        <div>
          <strong>Execução:&nbsp;</strong>
          {data.execution ?? 'Não informado'}
        </div>

        <div>
          <strong>Volume Nº de séries:&nbsp;</strong>
          {data.series_number ?? 'Não informado'}
        </div>

        <div>
          <strong>Volume Nº de repetições:&nbsp;</strong>
          {data.volume_total ?? 'Não informado'}
        </div>

        <div>
          <strong>Tempo de ação total:&nbsp;</strong>
          {data.total_action ?? 'Não informado'} minuto(s)
        </div>

        <div>
          <strong>Intervalo de recuperação total (entre séries):&nbsp;</strong>
          <br />
          {restTime ?? 'Não informado'} minuto(s)
        </div>

        <div>
          <strong>Tempo total:&nbsp;</strong>
          {data.total_time ?? 'Não informado'} minuto(s)
        </div>
      </Wrapper>
    </Container>
  );
}
